import { render, staticRenderFns } from "./SeaForce.vue?vue&type=template&id=b54e29a8&scoped=true"
import script from "./SeaForce.vue?vue&type=script&lang=js"
export * from "./SeaForce.vue?vue&type=script&lang=js"
import style0 from "./SeaForce.vue?vue&type=style&index=0&id=b54e29a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54e29a8",
  null
  
)

export default component.exports